import type { Client } from '@frontend/api-types';
import { useFeatureIsOn } from '@frontend/react';
import { applyClass, concatClasses } from '@frontend/web-utils';
import { Avatar } from './Avatar';
import { YStack } from './Containers/Stacks/YStack';
import { Text } from './Texts/Text';
import { Title } from './Texts/Title';

export type SidebarUserInfoProps = {
  isCollapsed: boolean;
  onClick?: () => void;
  userInfo: Client;
};

export const SidebarUserInfo = ({ isCollapsed, onClick, userInfo }: SidebarUserInfoProps) => {
  const { enabled: isGameplanPricingEnabled } = useFeatureIsOn('is_gameplan_pricing_enabled');
  return (
    <button
      // eslint-disable-next-line tailwindcss/no-custom-classname
      className={concatClasses(
        'sidebar-hover-background-effect gap-x-sm p-md flex flex-1 flex-row rounded-lg w-full items-center',
        applyClass(!isCollapsed, 'border border-neutral-200'),
        applyClass(isCollapsed, 'justify-center'),
      )}
      disabled={!onClick}
      onClick={onClick}
    >
      <Avatar size="md" userInfo={userInfo} />
      {isCollapsed ? null : (
        <YStack className="grow-1 overflow-hidden">
          <Title
            color={isGameplanPricingEnabled ? 'dark' : 'primary'}
            lineClamp={1}
            title={`${userInfo.firstName} ${userInfo.lastName}`}
            type="h6"
          >
            {userInfo.firstName} {userInfo.lastName}
          </Title>
          <Text className="opacity-50" lineClamp={1} title={userInfo.email} type="p-sm">
            {userInfo.email}
          </Text>
        </YStack>
      )}
    </button>
  );
};
